import FirstComponent from './FirstComponent';

export default FirstComponent;
